import { CSSProperties } from 'react';
import { Column } from '@tanstack/react-table';
import { Theme } from '@material-ui/core';

export const getCommonPinningStyles = (
  column: Column<any>,
  theme: Theme,
  isHeader?: boolean,
): CSSProperties => {
  return {
    borderLeft: `1px solid ${theme.palette.grey[300]}`,
    right: `${column.getAfter('right')}px`,
    backgroundColor: theme.palette.white,
    position: 'sticky',
    zIndex: isHeader ? 4 : 3,
    padding: theme.spacing(0.5, 1),
    textAlign: 'center',
  };
};
